// Detección de plataforma UNIFICADA para offline-v2 (StorageAdapter, PhotoStore, etc.)

import { Capacitor } from '@capacitor/core'

export function isNativePlatform () {
  try {
    return Capacitor.isNativePlatform()
  } catch {
    return false
  }
}

export function isWebPlatform () {
  return !isNativePlatform()
}

/** Los plugins de Capacitor están disponibles apenas carga el bundle; no hay nada que esperar. */
export const nativeReady = Promise.resolve()
